var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',_vm._g(_vm._b({staticClass:"btn-circle",attrs:{"href":_vm.href(_vm.postUrl, _vm.post),"rel":"noopener","target":"_blank"}},'b-btn',_vm.$attrs,false),_vm.$listeners),[_c('fa',{attrs:{"icon":_vm.icon,"size":_vm.iconSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }